import { getCurrentInstance } from "vue";
import rollbar from "@/plugins/rollbar";

export function logRollbarError(message, payload = null) {
  if (getCurrentInstance()) {
    const { proxy } = getCurrentInstance();

    if (proxy && proxy.$rollbar) {
      if (payload === null) {
        proxy.$rollbar.error(message);
      } else {
        proxy.$rollbar.error(message, payload);
      }
    } else {
      console.error("Rollbar instance is not available.");
    }
  }
}

export function triggerTestExtensionError() {
  rollbar.error("Test extension error", {
    body: {
      trace: {
        frames: [
          {
            filename: "chrome-extension://some-extension/injected.js",
            lineno: 42,
            method: "someMethod",
          },
        ],
      },
    },
  });
}

export function triggerTestNormalError() {
  rollbar.error(
    "Test normal error",
    new Error("This should report to Rollbar"),
  );
}
